import React from 'react'
import Logo from '../Assets/Icons/cinknestlogo.svg'
import { Link } from 'react-router-dom'
import './Footer.scss'
import SchLogo from '../Assets/Images/scharmach-logo.webp'
import { useLanguage } from '../Contexts/LanguageContext'

const Footer = () => {
  const { language } = useLanguage();

  return (
    <div className='footer' id='kontakt'>
      <Link to='/'>
        <img src={Logo} alt="Cinknest Logo" className='footer-logo' />
      </Link>
      <div className='content'>
        <div className='left'>
          <h4>{language === 'polish' ? 'Linki' : 'Links'}</h4>
          <nav className='nav-left'>
            <ul>
              <li><a href='/#co-oferujemy'>{language === 'polish' ? 'Co oferujemy' : 'What We Offer'}</a></li>
              <li><a href='/#dlaczego-telegram'>{language === 'polish' ? 'Dlaczego telegram' : 'Why Telegram'}</a></li>
              <li><a href='/#analityka'>{language === 'polish' ? 'Analityka i jakość ruchu ' : 'Analytics and Traffic Quality'}</a></li>
              <li><a href='/#dla-kogo'>{language === 'polish' ? 'Dla kogo' : 'For Whom'}</a></li>
              <li><a href='/#kontakt'>{language === 'polish' ? 'Kontakt' : 'Contact'}</a></li>
            </ul>
          </nav>

        </div>
        <div className='middle'>
          <h4>{language === 'polish' ? 'Informacje prawne' : 'Legal Information'}</h4>
          <nav className='nav-middle'>
            <ul>
              <li><Link to='/polityka-prywatnosci'>{language === 'polish' ? 'Polityka prywatności' : 'Privacy Policy'}</Link></li>

            </ul>
          </nav>

        </div>
        <div className='right'>
          <h4>{language === 'polish' ? 'Dane firmy' : 'Company Data'}</h4>
          <p>{language === 'polish' ? 'Nazwa firmy: Cinknest' : 'Company Name: Cinknest'}</p>
          <p>{language === 'polish' ? 'Adres: ul. Przykładowa 123' : 'Address: ul. Przykładowa 123'}</p>
          <p>{language === 'polish' ? '00-001 Warszawa' : '00-001 Warsaw'}</p>
          <p>{language === 'polish' ? 'NIP: 123-45-67-890' : 'VAT ID: 123-45-67-890'}</p>
        </div>
      </div>
      <div className='bottom-bar'>
        <div className='bottom-left'>
          <span>
            {language === 'polish' ? (
              <>
                Copyright © {new Date().getFullYear()} Nexus Group sp. z o.o. Wszystkie prawa do treści zastrzeżone.
              </>
            ) : (
              <>
                Copyright © {new Date().getFullYear()} Nexus Group sp. z o.o. All rights reserved.
              </>
            )}
          </span>

        </div>
        <div className='bottom-right'>
          <span>{language === 'polish' ? 'Projekt i wdrożenie: ' : 'Project and Implementation: '}</span>
          <a href='https://scharmach.pl/' target='_blank' rel='noopener noreferrer'>
            <img src={SchLogo} alt="Scharmach Logo" className='sch-logo' />
          </a>
        </div>
      </div>

    </div>
  )
}

export default Footer